import * as types from '../constants/customerdetails'

const initialState = {
  Status: null,
  apiPostResult: null,
  customerdetailsList: null,
  customerdetails: null,
  isCheckerEnabled: null,
  isADEnabled: null
}

export function getCustomer(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_CUSTOMER_REQUEST:
      return {
        ...initialState,
        Status: true
      };
    case types.FETCH_CUSTOMER_REQUEST_COMPLETED:
      return {
        ...state,
        Status: false,
        apiPostResult: true,
        customerdetails: action.data
      };
    case types.FETCH_CUSTOMER_REQUEST_ERROR:
      return {
        ...state,
        Status: false,
        apiPostResult: false,
        customerdetails: action.error
      };
    case types.FETCH_CUSTOMER_RESET:
      return {
        ...state,
        Status: null,
        apiPostResult: null,
        customerdetailsList: null,
        customerdetails: null
      };
    case types.FETCH_IS_CHECKER_REQUEST:
      return {
        ...state,
        Status: true,
        apiPostResult: null,
        isCheckerEnabled: null
      };
    case types.FETCH_IS_CHECKER_REQUEST_COMPLETED:
      return {
        ...state,
        Status: false,
        apiPostResult: true,
        isCheckerEnabled: action.data
      };
    case types.FETCH_IS_CHECKER_REQUEST_ERROR:
      return {
        ...state,
        Status: false,
        apiPostResult: false,
        isCheckerEnabled: action.error
      };
    default:
      return state;
  }
}

export function getCustomerList(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_CUSTOMER_LIST_REQUEST:
      return {
        ...initialState,
        Status: true
      };
    case types.FETCH_CUSTOMER_LIST_REQUEST_COMPLETED:
      return {
        ...state,
        Status: false,
        apiPostResult: true,
        customerdetailsList: action.data
      };
    case types.FETCH_CUSTOMER_LIST_REQUEST_ERROR:
      return {
        ...state,
        Status: false,
        apiPostResult: false,
        customerdetailsList: action.error
      };
    // case types.FETCH_CUSTOMER_LIST_RESET:
    //   return {
    //     ...initialState,
    //     Status: null,
    //     apiPostResult: null,
    //     customerdetailsList: null,
    //     customerdetails: null
    //   };
    default:
      return state;
  }
}

const add_initialState = {
  Status: null,
  apiPostResult: null
}
export function addCustomer(state = add_initialState, action) {
  switch (action.type) {
    case types.ADD_CUSTOMER_INITIAL:
      return {
        ...add_initialState,
        Status: null,
        apiPostResult: null
      };
    case types.ADD_CUSTOMER_REQUEST:
      return {
        ...state,
        Status: true
      };
    case types.ADD_CUSTOMER_REQUEST_COMPLETED:
      return {
        ...state,
        Status: false,
        apiPostResult: true
      };
    case types.ADD_CUSTOMER_REQUEST_ERROR:
      return {
        ...state,
        Status: false,
        apiPostResult: false
      };
    default:
      return state;
  }
} 


// WEBPACK FOOTER //
// ./reducers/customerdetails.js